<template>
    <v-container>
      <v-btn
      @click="goBack">
        Zpět
      </v-btn>
      <v-row>
        <v-col cols="12" class="text-h1" style="display: flex; justify-content: center">
          403
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'Unauthorized',
  methods: {
    goBack () {
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>

</style>
